import reducer from './programs';
import { actionCreators, ProgramsActionType } from './programs.actionCreators';
import * as actionTypes from './programs.actionTypes';

export * from './programs';
export * from './programs.selectors';
export type ActionType = ProgramsActionType;
export { actionTypes, actionCreators };
export default reducer;
